import React from "react";

const Hypertension = ({ exams }) => {
    const toNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        return typeof v === 'number' ? v : Number(v);
    };

    const getMessage = (sistolicaRaw, diastolicaRaw) => {
        const sistolica = toNumber(sistolicaRaw);
        const diastolica = toNumber(diastolicaRaw);
        if (Number.isNaN(sistolica) || Number.isNaN(diastolica)) return '';
        return (sistolica < 130 && diastolica < 80) ? 'En rango' : 'Fuera de rango';
    };

    const formatBP = (sistolica, diastolica) => {
        const s = sistolica ?? '';
        const d = diastolica ?? '';
        if (s === '' && d === '') return '';
        return `${s}/${d}`;
    };

    return (
        <>
            {exams.map((item, pos) => {
                const message = getMessage(
                    item?.currentLastResult?.sistolica ?? null,
                    item?.currentLastResult?.diastolica ?? null
                );

                return (
                    <React.Fragment key={pos}>
                        {item?.healthBenefitName === 'Toma de presion 1' ? (
                            <tr>
                                <td>Sistólica/Diastólica</td>
                                <td>
                                    {item?.hasPreviousYear
                                        ? formatBP(
                                            item?.previousLastResult?.sistolica ?? null,
                                            item?.previousLastResult?.diastolica ?? null
                                        )
                                        : ''}
                                </td>
                                <td>
                                    {item?.hasCurrentYear
                                        ? formatBP(
                                            item?.currentLastResult?.sistolica ?? null,
                                            item?.currentLastResult?.diastolica ?? null
                                        )
                                        : ''}
                                </td>
                                <td>Menor 130/80</td>
                                <td>{message}</td>
                            </tr>
                        ) : null}
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default Hypertension;
